import { render, staticRenderFns } from "./PointGpayForm.vue?vue&type=template&id=b07f03c8"
import script from "./PointGpayForm.vue?vue&type=script&lang=js"
export * from "./PointGpayForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports